import React, { useState, useEffect, useRef } from 'react';
import './Equipe.css';
import adamoSocialsImage from '../assets/adamo_socials.jpg';
import patSavImage from '../assets/pat_sav.jpg';

const Equipe = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isPatFlipped, setIsPatFlipped] = useState(false);
  const cardRef = useRef(null);
  const patCardRef = useRef(null);

  // Social Media SVG Icon Components
  const FacebookIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );

  const TwitchIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm16.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h15.714Z"/>
    </svg>
  );

  const InstagramIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );

  const TikTokIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
  );

  const adamoSocialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/letempsdunemousse',
      icon: <FacebookIcon />,
      color: '#1877F2',
      isSvg: true
    },
    {
      name: 'Twitch',
      url: 'https://www.twitch.tv/adamogrosbig',
      icon: <TwitchIcon />,
      color: '#9146FF',
      isSvg: true
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/letempsdunemousse',
      icon: <InstagramIcon />,
      color: '#E4405F',
      isSvg: true
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@letempsdunemousse',
      icon: <TikTokIcon />,
      color: '#000000',
      isSvg: true
    }
  ];

  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If card is not in viewport and is flipped, reset to front
          if (!entry.isIntersecting && isFlipped) {
            setIsFlipped(false);
          }
        });
      },
      {
        threshold: 0, // Trigger when any part of the card leaves viewport
        rootMargin: '0px'
      }
    );

    observer.observe(card);

    return () => {
      observer.disconnect();
    };
  }, [isFlipped]);

  useEffect(() => {
    const card = patCardRef.current;
    if (!card) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If card is not in viewport and is flipped, reset to front
          if (!entry.isIntersecting && isPatFlipped) {
            setIsPatFlipped(false);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px'
      }
    );

    observer.observe(card);

    return () => {
      observer.disconnect();
    };
  }, [isPatFlipped]);

  return (
    <section className="equipe" id="equipe">
      <div className="container">
        <h2 className="equipe-title">L'ÉQUIPE</h2>
        <div className="section-divider"></div>
        <div className="equipe-content">
          <div className="equipe-text equipe-text-right">
            <h3 className="equipe-subtitle">Adamo Marinacci</h3>
            <p className="equipe-role">Animateur</p>
            <p className="equipe-description">
              <strong>LE TEMPS D'UNE MOUSSE</strong> est un podcast qui vous invite à prendre 
              le temps de découvrir des personnalités fascinantes à travers des conversations 
              authentiques et enrichissantes.
            </p>
            <p className="equipe-description">
              Animé par <strong>Adamo Marinacci</strong>, chaque épisode est l'occasion de 
              partager une mousse tout en explorant des histoires captivantes, des débats 
              passionnants et des moments inoubliables.
            </p>
          </div>
          
          <div className="equipe-card-wrapper">
            <div className="equipe-tilted-card" ref={cardRef}>
              <div 
                className={`flip-card ${isFlipped ? 'flipped' : ''}`}
                onClick={() => setIsFlipped(!isFlipped)}
              >
                <div className="flip-card-inner">
                  {/* Front of card - Image */}
                  <div className="flip-card-front">
                    <div className="adamo-image-container">
                      <img 
                        src={adamoSocialsImage} 
                        alt="Adamo Marinacci" 
                        className="adamo-image"
                      />
                    </div>
                  </div>
                  
                  {/* Back of card - Social Links */}
                  <div className="flip-card-back">
                    <div className="social-links-container">
                      <h3 className="social-links-title">Suivez Adamo</h3>
                      <div className="social-links-grid">
                        {adamoSocialLinks.map((social, index) => (
                          <a
                            key={index}
                            href={social.url || '#'}
                            className="social-link-item"
                            target={social.url ? "_blank" : undefined}
                            rel={social.url ? "noopener noreferrer" : undefined}
                            style={{ '--social-color': social.color }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!social.url) {
                                e.preventDefault();
                              }
                            }}
                          >
                            <div className={`social-link-icon ${social.isSvg ? 'social-link-icon-svg' : ''}`}>
                              {social.icon}
                            </div>
                            <span className="social-link-name">{social.name}</span>
                          </a>
                        ))}
                      </div>
                      <div className="fun-fact">
                        <p className="fun-fact-label">FUN FACT:</p>
                        <p className="fun-fact-text">Adamo peut boire une mousse en moins de 3 secondes... mais préfère prendre son temps pour savourer chaque conversation! 🍻</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pat Savard Section - Mirrored Layout */}
        <div className="equipe-content equipe-content-mirrored">
          <div className="equipe-card-wrapper">
            <div className="equipe-tilted-card" ref={patCardRef}>
              <div 
                className={`flip-card ${isPatFlipped ? 'flipped' : ''}`}
                onClick={() => setIsPatFlipped(!isPatFlipped)}
              >
                <div className="flip-card-inner">
                  {/* Front of card - Image */}
                  <div className="flip-card-front">
                    <div className="adamo-image-container">
                      <img 
                        src={patSavImage} 
                        alt="Pat Savard" 
                        className="adamo-image"
                      />
                    </div>
                  </div>
                  
                  {/* Back of card - Social Links */}
                  <div className="flip-card-back">
                    <div className="social-links-container">
                      <h3 className="social-links-title">Suivez Pat</h3>
                      <div className="social-links-grid">
                        {adamoSocialLinks.map((social, index) => (
                          <a
                            key={index}
                            href={social.url || '#'}
                            className="social-link-item"
                            target={social.url ? "_blank" : undefined}
                            rel={social.url ? "noopener noreferrer" : undefined}
                            style={{ '--social-color': social.color }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!social.url) {
                                e.preventDefault();
                              }
                            }}
                          >
                            <div className={`social-link-icon ${social.isSvg ? 'social-link-icon-svg' : ''}`}>
                              {social.icon}
                            </div>
                            <span className="social-link-name">{social.name}</span>
                          </a>
                        ))}
                      </div>
                      <div className="fun-fact">
                        <p className="fun-fact-label">FUN FACT:</p>
                        <p className="fun-fact-text">Pat a déjà interviewé un chat... et c'était l'épisode le plus silencieux mais le plus mignon! 🐱</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="equipe-text">
            <h3 className="equipe-subtitle">Pat Savard</h3>
            <p className="equipe-role">Co-animateur</p>
            <p className="equipe-description">
              <strong>Pat Savard</strong> apporte sa passion et son expertise en tant que 
              co-animateur du podcast. Ensemble, Adamo et Pat créent une dynamique unique 
              qui enrichit chaque conversation.
            </p>
            <p className="equipe-description">
              Leur complémentarité permet d'explorer les sujets sous différents angles, 
              offrant aux auditeurs une expérience riche et variée à chaque épisode.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Equipe;

